import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LOAN_STAGES } from "@/components/StagePill";
import KanbanBoard from "@/components/KanbanBoard";
import DealsTable from "@/components/DealsTable";
import ViewToggle from "@/components/ViewToggle";
import ReferralLinkCard from "@/components/ReferralLinkCard";

function Datum({ label, value }) {
  return (
    <div>
      <div className="small-caps text-slate-500">{label}</div>
      <div className="mt-3 font-semibold text-[44px] leading-none text-[#1F2937]">{value}</div>
    </div>
  );
}

export default function LoanRepDashboard() {
  const [metrics, setMetrics] = useState({});
  const [apps, setApps] = useState([]);
  const [view, setView] = useState(() => localStorage.getItem("vn_pipeline_view") || "table");
  useEffect(() => localStorage.setItem("vn_pipeline_view", view), [view]);
  useEffect(() => {
    api.get("/metrics/loan-rep").then((r) => setMetrics(r.data)).catch(() => {});
    api.get("/applications").then((r) => setApps(r.data)).catch(() => {});
  }, []);
  const grouped = LOAN_STAGES.reduce((acc, s) => { acc[s] = apps.filter((a) => a.stage === s); return acc; }, {});

  return (
    <div className="max-w-[1200px] space-y-16" data-testid="loanrep-dashboard">
      <header>
        <div className="small-caps text-slate-500">Your portfolio</div>
        <h1 className="mt-6 font-semibold text-[72px] leading-[0.9] tracking-tight text-[#1F2937]">
          The <span className="italic">book.</span>
        </h1>
      </header>

      <section className="hair-y py-10 grid grid-cols-2 lg:grid-cols-4 gap-10">
        <Datum label="Active Files" value={metrics.active_files ?? 0} />
        <Datum label="New Submissions" value={metrics.new_applications ?? 0} />
        <Datum label="Pending Documents" value={metrics.pending_documents ?? 0} />
        <Datum label="Funded" value={metrics.funded ?? 0} />
      </section>

      <ReferralLinkCard role="loan_rep" />

      <section>
        <div className="small-caps text-slate-500">Pipeline</div>
        <h2 className="mt-3 font-semibold text-[32px] text-[#1F2937]">Book by stage</h2>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-5 gap-0 hair-y">
          {LOAN_STAGES.slice(0, 10).map((s, i) => (
            <div key={s} className={`py-6 px-5 ${i > 0 && i % 5 !== 0 ? "border-l border-[#1F2937]/10" : ""} ${i >= 5 ? "md:border-t md:border-[#1F2937]/10" : ""}`}>
              <div className="small-caps text-slate-500 text-[10px]">{s}</div>
              <div className="mt-3 font-semibold text-[32px] text-[#1F2937]">{grouped[s]?.length || 0}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="flex items-center justify-end">
        <ViewToggle value={view} onChange={setView} testid="loanrep-view-toggle" />
      </div>
      {view === "kanban" ? (
        <KanbanBoard title="Your active deals" subtitle="Drag to update position" />
      ) : (
        <DealsTable title="Your active deals" subtitle="Spreadsheet" />
      )}
    </div>
  );
}
